import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PaperPlaneTilt } from "@phosphor-icons/react";

const TARGETS = [
  { v: "all", l: "Tous les utilisateurs" },
  { v: "trialing", l: "En période d'essai" },
  { v: "active", l: "Abonnés actifs" },
  { v: "canceled", l: "Abonnements annulés" },
  { v: "admins", l: "Administrateurs" },
];

export default function AdminEmails() {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [target, setTarget] = useState("all");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const send = async () => {
    if (!subject.trim() || !message.trim()) { toast.error("Sujet et message requis"); return; }
    setSending(true);
    setResult(null);
    try {
      const { data } = await api.post("/admin/broadcast", { subject, message, target });
      setResult(data);
      toast.success(`Email envoyé à ${data.sent}/${data.recipients} destinataire(s)`);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-2xl" data-testid="admin-emails">
      <div className="overline mb-2">Communication</div>
      <h1 className="font-display text-3xl font-bold mb-8">Envoyer un email aux utilisateurs</h1>

      <div className="surface rounded-lg p-6 space-y-4">
        <div>
          <label className="overline block mb-1.5">Destinataires</label>
          <Select value={target} onValueChange={setTarget}>
            <SelectTrigger className="bg-surface-2 border-border" data-testid="email-target"><SelectValue /></SelectTrigger>
            <SelectContent>{TARGETS.map((t) => <SelectItem key={t.v} value={t.v}>{t.l}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div>
          <label className="overline block mb-1.5">Sujet</label>
          <Input className="bg-surface-2 border-border text-fg" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Nouveauté interKO…" data-testid="email-subject" />
        </div>
        <div>
          <label className="overline block mb-1.5">Message</label>
          <Textarea className="bg-surface-2 border-border text-fg min-h-[160px]" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Votre message (les sauts de ligne sont conservés)…" data-testid="email-message" />
        </div>
        <button onClick={send} disabled={sending} data-testid="email-send-btn"
          className="flex items-center gap-2 bg-accent text-black font-semibold px-5 py-2.5 rounded-md hover-lift disabled:opacity-60">
          <PaperPlaneTilt size={16} weight="fill" /> {sending ? "Envoi…" : "Envoyer"}
        </button>

        {result && (
          <div className="text-sm text-muted border-t border-border pt-4" data-testid="email-result">
            {result.recipients} destinataire(s) · <span className="text-accent">{result.sent} envoyé(s)</span>{result.failed ? ` · ${result.failed} échec(s)` : ""}
          </div>
        )}
      </div>
      <p className="text-xs text-muted mt-4">Les emails sont envoyés via Resend depuis interKO &lt;notifications@interko.io&gt;.</p>
    </div>
  );
}
